import { defineComponent } from "vue";
import { mapState } from "pinia";
import { useApp } from "../../../pages-vue/App/useApp";

export default defineComponent({
    inject: ["dialogRef"],

    data() {
        return {
            dialogReference: this.dialogRef as any,
            organizationsList: [],
            selectedOrganization: null
        };
    },
    computed: {
        ...mapState(useApp, ["organizations"])
    },

    async mounted() {
        this.selectedOrganization = null;
        this.organizationsList = this.organizations.map((organization, index) => {
            return {
                name: organization.name,
                id: organization.id,
                message: ""
            };
        });
    },

    methods: {
        cancel() {
            this.dialogReference.close("cancel");
        },
        ok() {
            this.selectedOrganization.message = "success";
            this.dialogReference.close(this.selectedOrganization);
        }
    }
});
